import React, {useState, useEffect, useRef, useMemo} from 'react';
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Dropdown} from "primereact/dropdown";
import axios from "axios";
import {ColumnGroup} from "primereact/columngroup";
import {Row} from "primereact/row";

const ReceiptRevenueAllocationListComponent = (props) => {

  const {t} = props;
  const [receiptRevenueAllocations, setReceiptRevenueAllocations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const dt = useRef(null);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'id',
    sortOrder: -1,
  });

  let loadLazyTimeout = null;
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      let query = window.App.transformQueryParams(lazyParams)
      apiCall('get', '/api/v2/revenue-allocation?search[receipt][operator]==&search[receipt][value]=' + window.App.state?.props?.id + query)
        .then(response => {
          setTotalRecords(response.data.data.total_item_count);
          setReceiptRevenueAllocations(response.data.data.items);
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const formatCurrency = (value, currencyCode) => {
    const currency = currencyCode;
    return window.App?.currencyFormatter
      ? window.App.currencyFormatter(currency, value)
      : <>{Number(value || 0)}&nbsp;{currency}</>;
  };

  const totalAmount = useMemo(() => {
    return (receiptRevenueAllocations || []).reduce((sum, row) => sum + Number(row?.amount || 0), 0);
  }, [receiptRevenueAllocations]);

  const footerGroup = (
    <ColumnGroup>
      <Row>
        <Column footer={t('grandTotal')} colSpan={2} footerStyle={{textAlign: 'right', fontWeight: 600}} />
        <Column footer={formatCurrency(totalAmount, receiptRevenueAllocations[0]?.currency)} footerStyle={{textAlign: 'left', fontWeight: 700}} />
      </Row>
    </ColumnGroup>
  );

  useEffect(() => {
    loadLazyData();
  }, [lazyParams, window.App.state.rerenderReceiptRevenueAllocationList])

  return (
    <>
      <DataTable size={localStorage.getItem('scale')}
                 emptyMessage={t('noResults')}
                 value={receiptRevenueAllocations} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
                 onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                 onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
                 paginatorTemplate={pager} rows={rows}
                 autoLayout={true}
                 
                 footerColumnGroup={footerGroup}
                 filterDisplay="row"
                 responsiveLayout="scroll"
                 stripedRows
                 ref={dt}
                 dataKey="id"
      >
        <Column field="revenue_item.name" header={t('columnName')} sortable filter></Column>
        <Column field="profit_center.name" header={t('fieldProfitCenter')} sortable filter></Column>
        <Column field="amount" header={t('columnAmount')} sortable body={(rowData) => (
          <>
            {formatCurrency(rowData?.amount, rowData?.currency)}
          </>
        )}
      />
      </DataTable>
    </>
  )
}
export default withTranslation('common')(ReceiptRevenueAllocationListComponent);
